import { FC } from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';
import { UserProcResponse } from '@/shared/api';
import { PageLayoutHeaderGoBackBtn } from '@/widgets/page-layout';

const { Title } = Typography;

type Props = {
  procInstance?: UserProcResponse;
};

export const UserProcInstancePageHeader: FC<Props> = ({ procInstance }) => {
  return (
    <HeaderWrapper>
      <PageLayoutHeaderGoBackBtn
        path={`/dashboard/author/proc/${procInstance?.parentProcId}/instances`}
        label="Go back to instances"
      />
      <TitleWrapper>
        <Title level={5} style={{ margin: 0 }}>
          {procInstance?.owner.email}
        </Title>
      </TitleWrapper>
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleWrapper = styled.div`
  width: 100%;
  padding-inline: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
